import { bemJoin } from '@app/lib/bem'
import { createLayoutComponent } from '@app/lib/createLayoutComponent'

import './Timeline.scss'

const b = bemJoin('timeline')

export const Timeline = createLayoutComponent('div', b(), {
  Item: createLayoutComponent('div', b('item'), {
    Time: createLayoutComponent('time', b('time')),
    Icon: createLayoutComponent('div', b('icon')),
    Entry: createLayoutComponent('div', b('entry'))
  })
})
